import { render } from "./PcIndex.vue?vue&type=template&id=524cefcb"
import script from "./PcIndex.vue?vue&type=script&lang=js"
export * from "./PcIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__